export default __webpack_public_path__ + "static/media/50_3_0.cb7f93fb.png";